
import React from 'react';
import { Rss, Wifi } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface RSSIndicatorProps {
  isUsingRSS: boolean;
}

const RSSIndicator = ({ isUsingRSS }: RSSIndicatorProps) => {
  if (!isUsingRSS) return null;

  return (
    <div className="flex items-center gap-2 mb-4 p-3 bg-orange-50 dark:bg-orange-900/20 rounded-lg border border-orange-200 dark:border-orange-800">
      <Rss className="h-4 w-4 text-orange-600" />
      <div className="flex-1">
        <p className="text-sm font-medium text-orange-800 dark:text-orange-200">
          Mode RSS activé
        </p>
        <p className="text-xs text-orange-600 dark:text-orange-300">
          Fallback RSS actif. Utilisation des flux RSS YouTube (données limitées).
        </p>
      </div>
      <Badge variant="outline" className="border-orange-300 text-orange-700">
        RSS
      </Badge>
    </div>
  );
};

export default RSSIndicator;
